import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadNthUserOnboardingCompletedTimestamp = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP],
		},
	});
};
